const AWARD_INITIAL_STATE = {
  isFetchLoading: false,
  isSimpleDetailsLoading: false,
  fetchError: undefined,
  simpleDetailsError: undefined,
  data: undefined,
}

export default AWARD_INITIAL_STATE
